'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserEmailBatchQueue } from '../../Entities/User/UserEmailBatchQueue';
import { UserEmailBatchQueueCollection } from '../../Collections/User/UserEmailBatchQueueCollection';

export class UserEmailBatchQueueRepository extends CoreRepository {
  public createUserEmailBatchQueue(
    userId: number,
    emailBatchQueueId: number,
    payload: object = {}
  ) {
    return this.webAPI
      .createUserEmailBatchQueue(userId, emailBatchQueueId, payload)
      .then((response) => {
        const userEmailBatchQueue = new UserEmailBatchQueue();
        userEmailBatchQueue.hydrate(response);

        return userEmailBatchQueue;
      });
  }

  public getUserEmailBatch(
    userId: number,
    batchId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserEmailBatchQueue(userId, batchId, options).then((response) => {
      const collection = new UserEmailBatchQueueCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserEmailBatchQueue();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
